import { useRef, useContext } from "react";
import { Box } from "@mui/material";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Toolbar,
  ExcelExport,
  Group,
  Filter,
  Selection,
  Sort,
  Page,
} from "@syncfusion/ej2-react-grids";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { selectedContext } from "../../pages/ShipmentsReport";

const CustomLink = styled(Link)`
  color: #2eafc8;
  font-weight: 500;
  text-decoration: none;
`;
// using react context may become more performant than passing state to props
const ReportsTable = (props) => {
  const { setSelected, selected } = useContext(selectedContext);
  let { rows, currentStatus } = props;
  let isDelivered = currentStatus === "delivered";

  const toolbarOptions = ["ExcelExport", "CsvExport"];
  const { t, i18n } = useTranslation("reports");
  const { language } = i18n;
  const gridInstance = useRef(null);

  const toolbarClick = (args) => {
    // eslint-disable-next-line default-case
    switch (args.item.text) {
      case "Excel Export":
        if (selected.length > 0) {
          // Export only selected rows
          const selectedData = rows.filter(row => selected.includes(row.AWB));
          gridInstance.current.excelExport({ dataSource: selectedData });
        } else {
          // Export all data if no selection
          gridInstance.current.excelExport();
        }
        break;
      case "CSV Export":
        if (selected.length > 0) {
          // Export only selected rows
          const selectedData = rows.filter(row => selected.includes(row.AWB));
          gridInstance.current.csvExport({ dataSource: selectedData });
        } else {
          // Export all data if no selection
          gridInstance.current.csvExport();
        }
        break;
    }
  };
  const handleRowSelection = (e) => {
    if (e.isHeaderCheckboxClicked === true) {
      // Select all data across all pages
      const allAwbs = rows.map((shipment) => shipment.AWB);
      setSelected(allAwbs);
    } else {
      setSelected((selected) => [...selected, e.data.AWB]);
    }
  };
  const handleRowDeSelection = (e) => {
    if (e.isHeaderCheckboxClicked === true) {
      setSelected([]);
    } else {
      setSelected(
        selected.filter((shipment) => {
          return shipment !== e.data.AWB;
        })
      );
    }
  };

  return (
    <Box>
      <GridComponent
        enableRtl={language === "ar" ? true : false}
        dataSource={rows}
        rowSelected={handleRowSelection}
        rowDeselected={handleRowDeSelection}
        selectionSettings={{ type: "checkbox" }}
        ref={gridInstance}
        toolbar={toolbarOptions}
        filterSettings={{ type: "Excel" }}
        allowSorting
        allowExcelExport
        enableStickyHeader
        allowFiltering
        allowGrouping
        toolbarClick={toolbarClick}
        allowPaging={true}
        pageSettings={{ pageCount: 5, pageSize: 10 }}
        tooltip={{ enable: true }}
      >
        <ColumnsDirective>
          <ColumnDirective width={70} type="checkbox"></ColumnDirective>
          <ColumnDirective
            template={(e) => {
              return <CustomLink to={`/shipment/${e.AWB}`}>{e.AWB}</CustomLink>;
            }}
            field="AWB"
            headerText={t("awb")}
            width="120"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="ToRef"
            headerText={t("ref")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="SpecialInstuctions"
            headerText={t("specialInstructions")}
            width="350"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="ReasonNameA"
            headerText={t("reason")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="UpdateNotes"
            headerText={t("UpdateNotes")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="StatusNameA"
            headerText={t("status")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="IDNO"
            headerText={t("IDNO")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="ProductName"
            headerText={t("ProductName")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="FromContactPerson"
            headerText={t("FromContactPerson")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="ShipmentTypeName"
            headerText={t("ShipmentTypeName")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="DeclaredValue"
            headerText={t("DeclaredValueCOD")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="COD"
            headerText={t("COD")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          
          <ColumnDirective
            field="ShipmentFees"
            headerText={t("fees")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="NetCOD"
            headerText={t("NetCOD")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          {isDelivered ? (
            <ColumnDirective
              field="DeliveryDate"
              headerText={t("DeliveryDate")}
              width="150"
              clipMode="EllipsisWithTooltip"
            ></ColumnDirective>
          ) : (
            ""
          )}
          
          {/* <ColumnDirective
            field="runnerData"
            headerText={t("runner")}
            width="240"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective> */}
          <ColumnDirective
            field="ToConsigneeName"
            headerText={t("consignee")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="PickupDate"
            headerText={t("PickupDate")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          {/* <ColumnDirective
            field="FromBranch"
            headerText={t("FromBranch")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="ToBranch"
            headerText={t("ToBranch")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>

          <ColumnDirective
            field="CurrentBranch"
            headerText={t("CurrentBranch")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective> */}

          <ColumnDirective
            headerText={t("city")}
            field="ToCityName"
            width="120"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            headerText={t("address")}
            width="150"
            field="ToAddress"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            headerText={t("phone")}
            field="ToPhone"
            width="260"
            clipMode="EllipsisWithTooltip"
            template={(e) => {
              return (
                <>
                  {e.ToPhone} {e.ToMobile ? `(${e.ToMobile})` : ""}
                </>
              );
            }}
          ></ColumnDirective>
          <ColumnDirective
            headerText={t("payment_value")}
            field="PaymentValue"
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            headerText={t("paid")}
            width="120"
            field="PaidToCust"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
        </ColumnsDirective>
        <Inject
          services={[
            Toolbar,
            ExcelExport,
            Group,
            Page,
            Filter,
            Selection,
            Sort,
          ]}
        />
      </GridComponent>
    </Box>
  );
};

export default ReportsTable;
